import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogSendConfirmationProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogSendConfirmation: React.FC<TDialogSendConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="sm"
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-publish-data.png"
            alt="Document Icon"
            width={84}
            height={84}
          />
          <Text variant="display-sm">Konfirmasi untuk Ajukan Perencanaan</Text>
          <Text variant="body-lg">
            Perencanaan tidak dapat diubah lagi dan akan diperiksa oleh Tim
            Kinerja dan Pejabat Penilai Kinerja.
          </Text>

          <div className="grid grid-cols-2 gap-x-4">
            <Button
              data-testid="dialog-send-confirm-back"
              className="w-32"
              color="white"
              size="lg"
              fullWidth
              onClick={onClose}
            >
              Kembali
            </Button>
            <Button
              data-testid="dialog-send-confirm-submit"
              className="w-32"
              color="blue"
              size="lg"
              fullWidth
              onClick={onConfirm}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
